import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.loadData()
  }

  async loadData() {
    try {
      // Make a Turbo Stream request - let the server render the HTML
      await fetch(this.urlValue, {
        method: 'GET',
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(response => {
        if (!response.ok) throw new Error("Failed to fetch ice cream data")
        return response.text()
      }).then(html => {
        // Let Turbo handle the stream response
        Turbo.renderStreamMessage(html)
      })
    } catch (error) {
      console.error("Error loading ice cream data:", error)
      // Update the container with error message - minimal HTML here
      const container = document.getElementById('mobile-ice-cream-container')
      if (container) {
        container.innerHTML = '<div class="text-red-500">Error loading data</div>'
      }
    }
  }
}
